<!-- 
  付款计划 组件
  prop: 
    attrValue: 绑定值
    payPlanType: 付款类型
    decimalPrecision: 付款金额精度
  emit: 
    emitPayPlan: 提交付款计划数据
 -->

<template>
  <div class="payPlan">
    <el-table
      border
      v-if="payPlan.length !== 0"
      :data="payPlan"
      style="width: 100%">
      <!-- 操作按钮 -->
      <el-table-column
        label="操作"
        width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            class="del"
            @click="delTel(scope.$index)"
            :disabled="scope.row.disabled">
            删除
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="付款金额(元)"
        width="130">
        <template slot-scope="scope">
          <el-input 
          :disabled="id !== '' && (scope.row.status === '2' || scope.row.status === '3')" 
          size="mini"
          v-model.number="scope.row.amount"
          @change="changeAmount(scope.$index)">
         </el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="付款编号"
        width="130">
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.planNo" 
          :disabled="nonEditable === 1 || (id !== '' && (scope.row.status === '2' || scope.row.status === '3'))">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="预计付款日期"
        width="180">
        <template slot-scope="scope">
          <el-date-picker
            size="small"
            v-model="scope.row.estimateTime"
            @click.native="currentIndex=scope.$index"
            @change="datepicker"
            :editable="false"
            :disabled="id !== '' && (scope.row.status === '2' || scope.row.status === '3')"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="预计付款时间">
          </el-date-picker>
        </template>
      </el-table-column>
      <el-table-column
        label="付款状态"
        width="130">
        <template slot-scope="scope">
          <el-select size="small" v-model="scope.row.status" placeholder="付款状态">
            <el-option
              v-for="(label, value) in payPlanStatus"
              :key="label"
              :label="label"
              :value="value"
              :disabled="(id !== '' && scope.row.status === '2') || value === '3'">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="付款类型"
        width="130">
        <template slot-scope="scope">
          <el-select size="small" v-model="scope.row.payType" placeholder="付款类型">
            <el-option
              v-for="item in payPlanTypes"
              :key="item.key"
              :label="item.value"
              :value="item.key"
              :disabled="id !== '' && (scope.row.status === '2' || scope.row.status === '3')">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
       <el-table-column
        label="付款说明"
        >
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.memo" 
          :disabled="id !== '' && (scope.row.status === '2' || scope.row.status === '3')"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div :class="{required: item && item.required === 1}">
      <el-button type="text" @click="addPlan"><i class="el-icon-plus"></i>添加付款计划</el-button>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {
  props: ['attrValue', 'payPlanType', 'item', 'decimalPrecision'],
  created () {
    if (this.attrValue && this.attrValue.length) {
      // 在后台传过来的数据中加入一个属性来判断删除按钮是否可用
      this.payPlan = this.attrValue.map((ob) => {
        if (ob.status === '1') {
          this.$set(ob, 'disabled', false)
        } else if (ob.status === '2' || ob.status === '3') {
          this.$set(ob, 'disabled', true)
        }
        return ob
      })
    }

    // 如果付款类型不存在，则动态获取
    if (!this.payPlanType) {
      this.getPayType()
    }

    this.id = this.$route.query.id || ''
  },
  data () {
    return {
      payPlanStatus: {
        1: '未付款',
        2: '已付款',
        3: '部分付款'
      },
      id: '',
      payPlanTypes: this.payPlanType,
      payPlan: [],
      currentIndex: '',
      nonEditable: 0 // 是否禁止编辑 付款编号
    }
  },
  methods: {
    datepicker (val) {
      if (this.payPlan[this.currentIndex]) {
        this.payPlan[this.currentIndex].estimateTime = val
      }
    },
    addPlan () {
      // 最多添加50条付款计划→
      const url = '/payPlan/getAutoSheetNo.html'
      api.post(url, {}, (data) => {
        // 是否禁止编辑 付款编号
        this.nonEditable = data.nonEditable
        this.payPlan.push({
          amount: '',
          planNo: data.result,
          estimateTime: '',
          status: '1',
          payType: '1',
          memo: ''
        })
        this.$emit('emitPayPlan', this.payPlan)
      })
    },
    delTel (index) {
      this.payPlan.splice(index, 1)
      this.$emit('emitPayPlan', this.payPlan)
    },

    // 付款金额精度
    changeAmount (index) {
      let amount = Number(this.payPlan[index].amount).toString()
      // 付款管理新建用this.decimalPrecision,采购合同用this.item.decimalPrecision
      let decimalPrecision = this.decimalPrecision === undefined ? this.item.decimalPrecision : this.decimalPrecision
      if (amount.indexOf('.') !== -1) {
        var precisionLen = amount.split('.')[1].length // 获取input输入小数位的长度
        if (precisionLen > decimalPrecision) {
          // 如果小数位超出就提示
          let messageText = '限制了' + decimalPrecision + '位小数'
          Message({
            message: messageText,
            type: 'warning'
          })
        }
      }
      console.log(typeof amount)
      // 付款管理和采购合同用到
      this.payPlan[index].amount = Number(Number(amount).toFixed(decimalPrecision)) || ''
    },

    // 监听输入的金额是否为有效数字
    handleAmount (index) {
      let amount = this.payPlan[index].amount
      if (typeof amount !== 'number') {
        this.payPlan[index].amount = 0
      }
    },

    // 获取付款类型
    getPayType () {
      const url = '/payPlan/getPayType.html'
      api.post(url, {}, (data) => {
        this.payPlanTypes = data.result
      })
    }
  }
}
</script>
<style lang="less">
.payPlan {
  .el-input {
    width: 100% !important;
  }
  .date {
    .el-date-editor {
      width: 120px;
    }
  }
}
</style>

<style lang="less" scoped>
.payPlan {
  .item {
    display: flex;
    padding-top: 8px;
    span {
      padding-right: 2%;
      display: inline-block;
      vertical-align: top;
      line-height: 1;
    }
    .status {
      width: 160px;
    }
    .const {
      width: 100%;
      color: #999;
      background-color: #f5f5f5;
      border: 1px solid rgb(191, 203, 217, 0.6);
      line-height: 2;
      padding: 10px;
      border-radius: 4px;
      .text {
        margin-right: 12px;
      }
    }
  }
  &.required {
    &:before {
      content: "*";
      width: 15px;
      display: inline-block;
      color: red;
    }
  }
  .required {
    &:before {
      content: "*";
      width: 15px;
      display: inline-block;
      color: red;
    }
  }
}
</style>


// WEBPACK FOOTER //
// pay-plan.vue?2f706b47